// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc4569f8","857":"53b6f862"}[chunkId] + ".chunk.js";
};